import { companyDataDefinition } from './company-data-definition'
import { formulaDefinition } from './formula-definition'
import { followCompaniesDefinition } from './follow-companies-definition'
import { bookyearEndDefinition } from './bookyear-end-definition'
import { reconciliationResultDefinition } from './reconciliation-result-definition'
import { workflowProgressDefinition } from './workflow-progress-definition'
import { workflowSharingStatusDefinition } from './workflow-sharing-status-definition'
import { workflowStatusDefinition } from './workflow-status-definition'
import { periodLockedDefinition } from './period-locked-definition'
import { submissionDataDefinition } from './submission-data-definition'
import { workflowUsageDefinition } from './workflow-usage-definition'
import { companyGroupsDefinition } from './company-groups-definition'
import { preparationAndReviewDefinition } from './preparation-and-review-definition'
import { syncsInformationDefinition } from './syncs-information-definition'
import { templateStarringDefinition } from './template-starring-definition'
import { todosDefinition } from './todos-definition'

export const filterGroups = [
  {
    nameKey: 'client_information',
    filterTypes: [companyDataDefinition.type, bookyearEndDefinition.type],
  },
  {
    nameKey: 'financial_data',
    filterTypes: [reconciliationResultDefinition.type, formulaDefinition.type],
  },
  {
    nameKey: 'progression',
    filterTypes: [
      periodLockedDefinition.type,
      preparationAndReviewDefinition.type,
      workflowStatusDefinition.type,
      workflowProgressDefinition.type,
      todosDefinition.type,
      submissionDataDefinition.type,
    ],
  },
  {
    nameKey: 'users',
    filterTypes: [followCompaniesDefinition.type, companyGroupsDefinition.type],
  },
  {
    nameKey: 'pulse',
    filterTypes: [workflowSharingStatusDefinition.type],
  },
  {
    nameKey: 'configuration',
    filterTypes: [
      workflowUsageDefinition.type,
      templateStarringDefinition.type,
      syncsInformationDefinition.type,
    ],
  },
]

export const filterDefinitions = [
  companyDataDefinition,
  formulaDefinition,
  followCompaniesDefinition,
  bookyearEndDefinition,
  reconciliationResultDefinition,
  workflowProgressDefinition,
  workflowSharingStatusDefinition,
  workflowStatusDefinition,
  periodLockedDefinition,
  submissionDataDefinition,
  workflowUsageDefinition,
  companyGroupsDefinition,
  preparationAndReviewDefinition,
  syncsInformationDefinition,
  templateStarringDefinition,
  todosDefinition,
]
